/**
 * Shared UI Components
 */

export { ErrorBoundary } from "./Layout/ErrorBoundary";
export type { ErrorBoundaryProps, ErrorBoundaryState } from "./Layout/ErrorBoundary";

export { AppErrorFallback } from "./AppErrorFallback";
export type { AppErrorFallbackProps } from "./AppErrorFallback";

export { PageErrorFallback } from "./Layout/PageErrorFallback";
export type { PageErrorFallbackProps } from "./Layout/PageErrorFallback";

export { Layout } from "./AppShell";

// Unsaved-changes guard — moved from apps/main as Phase 1B of the
// external-consumption refactor. The widgets that use
// `useUnsavedChanges` (TradeWidget, stake forms) need it reachable
// from shared so they can be moved next.
export { UnsavedChangesProvider, useUnsavedChanges, useDirtyState, useGuardedNavigate } from "./UnsavedChangesProvider";
export { UnsavedChangesModal } from "./UnsavedChangesModal";

export { AnimatedLogo } from "./Brand/AnimatedLogo/AnimatedLogo";
export { SolomonLogo } from "./Brand/SolomonLogo";

export { ClaimLinkDialog, createClaimLinkDialogState, getClaimLinkDialogCopy } from "./org/ClaimLinkDialog";
export type {
    ClaimLinkClientTerm,
    ClaimLinkDialogCopy,
    ClaimLinkDialogState,
    ClaimLinkKind
} from "./org/ClaimLinkDialog";

export { OrgAuthCallbackPage, OrgAuthClaimPage, OrgAuthForgotPasswordPage, OrgAuthLoginPage } from "./Auth";

export { MobileWalletDrawer, TokenBalanceList, WalletAddress, WalletDropdown } from "./WalletMenu";
export type { TokenBalanceDisplay, WalletAddressProps, WalletMenuProps } from "./WalletMenu";

// Design-system atoms are NOT re-exported here. Import them directly from
// their files to keep the import graph shallow and match shadcn convention:
//   import { Button } from "@shared/components/ui/button";

// YaaS components
export {
    YaasClientStatusBadge,
    PolicyStatusBadge,
    YaasPositionStatusBadge,
    YaasPlaceholderCard,
    YaasShell,
    YaasSidebar,
    YaasStatCard,
    YaasStatCardSkeleton,
    YaasTopBar
} from "./Yaas";
export type { NavItem, NavDivider, NavSection, NavEntry, YaasConsoleKind, YaasTopBarUser, PolicyStatus } from "./Yaas";
